module.exports = __webpack_public_path__ + "static/img/user.59bea1ea.png";